import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {LfRoutes} from '@lightweightform/core';
import {NonUnionFormComponent} from './non-union-form/non-union-form.component';
import {NonUnionComponent} from './non-union.component';


const routes: LfRoutes = [
  {
    path: '',
    component: NonUnionComponent,
    children: [
      {path: '', redirectTo: 'non-union-form', pathMatch: 'full'},
      {path: 'non-union-form', component: NonUnionFormComponent},
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
